module.exports = __webpack_public_path__ + "img/submited.d749a31b.png";